import { SxProps } from '@mui/material'

const STAR_GOLD = '#FAC515'

export const starRatingClasses = {
  root: 'star-rating',
  star: 'star-icon',
  filled: 'star-filled',
  empty: 'star-empty',
}

export const starRatingStyles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    [`.${starRatingClasses.star}`]: {
      p: 0.25,
    },
    [`.${starRatingClasses.filled}`]: {
      color: STAR_GOLD,
    },
    [`.${starRatingClasses.empty}`]: {
      color: 'utils.gray200',
    },
  } as SxProps,
}

/** Sizes each star to `size` px */
export const getStarSizeSx = (size: number): SxProps => ({
  [`.${starRatingClasses.star}`]: {
    width: size,
    height: size,
  },
})
